import  io  from "socket.io-client";

const socket = io.connect(process.env.REACT_APP_BACKEND_URL); 
socket.on("connect", () => {
    console.log("Connected to the server");
  });

  socket.on("disconnect", () => { 
    console.log("Disconnected from the server");
  });
  
  socket.on("connect_error", (err) => {
    console.error("Connection Error: ", err);
  });

  
export default socket;
